<template>
  <v-layout justify-center>
  <v-flex xs12 sm8 md8 lg6 text-xs-center>
    <template v-if="this.showProfile">
    <v-img class="profile-image" :src="'img/profiilit_taustalla/'+results.image">
      <v-layout align-start justify-center column fill-height>
        <div :class="computeClass">
          <h2 class="title mb-2">Olet</h2>
          <h2 :class="determineFontsize">{{ results.profile }} </h2>
          <h3 class="body-2 mt-3">{{ results.description }}</h3>
        </div>  
      </v-layout>
    </v-img>
    
    <h3 class=".font-weight-light mb-1">Nyt tiedät millainen metsänkäyttäjä olet!</h3>
    <p>Käy antamassa <a href="https://urly.fi/10FY">palautetta</a> visasta!</p>
    <v-btn class="mb-3" @click="shareOnFacebook">Jaa Facebookissa</v-btn>
    </template>

    <!-- Tästä vaihtuu -->
    <base-profiles v-if="showBaseProfiles === true"></base-profiles>
    <latest-profiles v-if="showLatest === true" class="mb-2"></latest-profiles>
    <v-btn v-if="showBaseProfiles || showLatest" class="mb-3" @click="() => { this.showBaseProfiles=false; this.showLatest=false; this.showProfile=true}">Palaa tuloksiin</v-btn>
    
    <v-btn class="mb-3" @click="startQuiz">Tee testi uudelleen</v-btn>

    <v-btn v-if="!showBaseProfiles" class="mb-3" @click="() => {this.showBaseProfiles=true; this.showProfile=false}">Näytä perusprofiilit</v-btn>
    <v-btn v-if="!showLatest" class="mb-3" @click="() => { this.showLatest=true; this.showProfile=false}">Viimeisimmät tulokset</v-btn>



    <p class="body-1">
      Millainen metsänkäyttäjä olet -visa on toteutettu Metsäinen innostaa -hankkeessa. Hankkeen toteuttavat Suomen metsäkeskus, Suomen 4H-liitto ja Lapin ammattikorkeakoulu. Hankkeen on rahoittanut Lapin ELY-keskus Manner-Suomen maaseudun kehittämisohjelmasta 2014-2020.
    </p>

    <v-container xs12>
        <v-layout row  wrap>
        <v-flex xs6 md6>
            <v-card flat tile class="v-cardi">
                <v-img class="footer-logos" src="img/2016_metsakeskus_pysty.png" height="75px" contain />
            </v-card>
        </v-flex>
        <v-flex xs6 md6>
            <v-card flat tile class="v-cardi">
                <v-img class="footer-logos" src="img/lapinamk_cmyk.svg" height="75px" contain />
            </v-card>
        </v-flex>
        <v-flex xs6 md6>
            <v-card flat tile class="v-cardi">
                <v-img class="footer-logos" src="img/4H_RGB.png" height="75px" contain />
            </v-card>
        </v-flex>
        <v-flex xs6 md6>
            <v-card flat tile class="v-cardi">
                <v-img class="footer-logos" src="img/ELY.svg" height="75px" contain />
            </v-card>
        </v-flex>
        <v-flex xs6 md6>
            <v-card flat tile class="v-cardi">
                <v-img class="footer-logos" src="img/maaseutu.svg" height="75px"  contain />
            </v-card>
        </v-flex>
        </v-layout>
    </v-container>
  </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import BaseProfiles from "@/components/metsankayttaja/BaseProfiles.vue";
import LatestProfiles from "@/components/metsankayttaja/LatestProfiles.vue";

export default {
  name: "Results",
  components: {
    BaseProfiles,
    LatestProfiles
  },
  computed: {
    ...mapState("metsankayttaja", [
      "currentAnswers",
      "points",
      "profiles",
      "results",
      "profileCalculated"
    ]),
    computeClass() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "item ml-2";
        case "sm":
          return "item ml-5";
        case "md":
          return "item ml-5";
        case "lg":
          return "item ml-5";
        case "xl":
          return "item ml-5";
      }
    },
    determineFontsize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "title";
        case "sm":
          return "font-weight-light";
        case "md":
          return "font-weight-light";
        case "lg":
          return "font-weight-light";
        case "xl":
          return "font-weight-light";
      }
    }
  },
  data: function() {
    return {
      description: "",
      head: "img/osat/4H_seikkailija_pää.png",
      fbimage: "a-a-a.png",
      showBaseProfiles: false,
      showLatest: false,
      showProfile: true,
    };
  },
  methods: {
    startQuiz() {
      this.$store.dispatch("metsankayttaja/resetQuiz", {
        router: this.$router
      });
    },
    shareOnFacebook() {
      // eslint-disable-next-line
      FB.ui(
        {
          method: "share_open_graph",
          action_type: "og.likes",
          action_properties: JSON.stringify({
            object: {
              "og:url": "http://metsankayttaja.plab.fi",
              "og:title": "Olen " + this.results.profile,
              "og:description": "Löydä oma profiilisi Metsänkäyttäjä testillä!",
              "og:image":
                "http://metsankayttaja.plab.fi/img/profiilit/" +
                this.results.image
            }
          })
        },
        function() {}
      );
    }
  },
  mounted() {
    if (!this.profileCalculated) {
      this.$store.dispatch("metsankayttaja/getProfile");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.application .theme--light.v-card,
.theme--light .v-card {
  background: #f8fafa;
}

.profile {
  width: 343px;
  height: 600px;
  position: relative;
  margin: auto;
}

.item {
  max-width: 200px;
  color: white;
}

.profile2 {
  background: center / contain url("/img/4H_tulokset_tausta.png") no-repeat;
}

.profile-part-head,
.profile-part-torso,
.profile-part-legs {
  position: absolute;
  left: 0;
}

.profile-part-head {
  z-index: 2;
}

.profile-part-torso {
  z-index: 1;
}

.profile-part-legs {
  z-index: 0;
}
</style>
